import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./ArrayProperts.css";

function Projects() {
  const projects = [
    {
      id: 1,
      images: [
        "/assets/images/grand/44.jpeg",
        "/assets/images/grand/45.jpg",
        "/assets/images/grand/46.jpeg",
        "/assets/images/grand/47.jpeg",
        "/assets/images/grand/48.jpeg",
      ],
      title: "شقة جراند سيزر",
      category: "تشطيبات كاملة",
    },
    {
      id: 2,
      images: [
        "/assets/images/pro/pic11.jpeg",
        "/assets/images/pro/pic12.jpeg",
        "/assets/images/pro/pic13.jpeg",
      ],
      title: "شقة - الرحاب",
      category: "تشطيب فاخر",
    },
    {
      id: 3,
      images: [
        "/assets/images/tmr/tmr1.jpg",
        "/assets/images/tmr/tmr2.jpg",
        "/assets/images/tmr/tmr3.jpg",
        "/assets/images/tmr/tmr4.jpg",
      ],
      title: "فيلا - تمر حنه",
      category: "تصميم داخلي",
    },
    {
      id: 4,
      images: [
        "/assets/images/october/october1.jpg",
        "/assets/images/october/october2.jpg",
        "/assets/images/october/october3.jpg",
        "/assets/images/october/october4.jpg",
      ],
      title: "شقة - اكتوبر",
      category: "تشطيب إداري",
    },
    {
      id: 5,
      images: [
        "/assets/images/helm/helm1.jpg",
        "/assets/images/helm/helm2.jpg",
        "/assets/images/helm/helm3.jpg",
        "/assets/images/helm/helm4.jpg",
      ],
      title: "شقة - الحلمية",
      category: "تشطيب تجاري",
    },
    {
      id: 6,
      images: [
        "/assets/images/helwan/helwan1.jpg",
        "/assets/images/helwan/helwan2.jpg",
        "/assets/images/helwan/helwan3.jpg",
        "/assets/images/helwan/helwan4.jpg",
      ],
      title: "شقة - حلوان",
      category: "تشطيبات كاملة",
    },
    {
      id: 7,
      images: [
        "/assets/images/mali/mali1.jpg",
        "/assets/images/mali/mali2.jpg",
        "/assets/images/mali/mali3.jpg",
        "/assets/images/mali/mali4.jpg",
      ],
      title: "شقة - المالية",
      category: "تشطيب فاخر",
    },
    {
      id: 8,
      images: [
        "/assets/images/golf/golf1.jpg",
        "/assets/images/golf/golf2.jpg",
        "/assets/images/golf/golf3.jpg",
        "/assets/images/golf/golf4.jpg",
      ],
      title: "فيلا الجولف",
      category: "تشطيب طبي",
    },
    {
      id: 9,
      images: [
        "/assets/images/qrnfl/1000.png",
        "/assets/images/qrnfl/2000.png",
        "/assets/images/qrnfl/3000.png",
        "/assets/images/qrnfl/101.jpg",
      ],
      title: "فيلا القرنفل",
      category: "تشطيب محلات",
    },
  ];

  return (
    <section className="projects-page">
      <div className="projects-header text-center">
        <h1 className="projects-title">أعمالنا</h1>
        <div className="title-divider"></div>
        <p className="projects-subtitle">
          نماذج مختارة من المشاريع التي نفخر بتنفيذها بأعلى معايير الجودة
        </p>
      </div>

      {/* عنصر احترافي بدل الفلترة */}
      <div className="projects-highlight text-center mb-5">
        <div className="highlight-line"></div>
        <p className="highlight-text">
          تنفيذ احترافي • خامات معتمدة • التزام كامل بالمواعيد
        </p>
        <div className="highlight-line"></div>
      </div>

      <div className="container">
        <div className="row">
          {projects.map((project) => (
            <div key={project.id} className="col-lg-4 col-md-6 mb-4">
              <div className="project-box">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  navigation
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  loop={true}
                  className="project-swiper"
                >
                  {project.images.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img src={img} alt={project.title} />
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div className="project-info">
                  <span>{project.category}</span>
                  <h5>{project.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;